import { useEffect, useState } from "react";

interface UseTypewriterOptions {
  speed?: number;
  delay?: number;
}

export const useTypewriter = (
  text: string,
  { speed = 120, delay = 0 }: UseTypewriterOptions = {},
): { typedText: string; isDone: boolean } => {
  const [typedText, setTypedText] = useState("");
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    if (!text) return;

    setTypedText("");
    setIsDone(false);

    const timeout = setTimeout(() => {
      let i = 0;
      const interval = setInterval(() => {
        i++;
        setTypedText(text.slice(0, i));
        if (i >= text.length) {
          clearInterval(interval);
          setIsDone(true);
        }
      }, speed);

      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timeout);
  }, [text, speed, delay]);

  return { typedText, isDone };
};
